import { createWebHistory, createRouter } from "vue-router";

const alert = () => import("../alert/alert.vue");
const main = () => import("../main/main.vue");

const routes = [
  {
    path: "/alert",
    name: "alert",
    component: alert,
  },
  {
    path: "/",
    name: "main",
    component: main,
  },
];

export const router = createRouter({
  history: createWebHistory(),
  routes,
});
